// magic numbers... package_questions.question_number this should be the only place reports use magic numbers
const Qnos={
  allergy: 8,
  attendance: 6,
  food: 7,
  drink1: 10,
  drink2: 11,
  song: 30,
  assistance: 9,
  saree: 15,
  turban: 16,
  dhoti: 17,
  hijab: 18,
  mehndi: 12,
  mehndiHands: 13,
  mehndiLocation: 14,
  transfer: 21,
  stayHotel: 22,
  rooms: 23,
  extraBeds: 24,
  kidsAge: 25,
  hotel: 26,
  extendStay: 27,
  extendedStayDates: 28,
  excursions: 29,
  flightArrival: 19,
  arrivalFlight: 31,
  flightDeparture: 20,
  name: 1,
  email: 3,
  phone: 4,
  guestOf: 5,
}

function parseCSV(str) {
  // ineffecient but simple.
  const arr = [];
  let quote = false;

  for (let row = 0, col = 0, c = 0; c < str.length; c++) {
      let cc = str[c], nc = str[c+1];
      arr[row] = arr[row] || [];
      arr[row][col] = arr[row][col] || '';

      if (cc == '"' && quote && nc == '"') { arr[row][col] += cc; ++c; }
      else if (cc == '"') { quote = !quote; }
      else if (cc == ',' && !quote) { ++col; }
      else if (cc == '\r' && nc == '\n' && !quote) { ++row; col = 0; ++c; }
      else if (cc == '\n' && !quote) { ++row; col = 0; }
      else if (cc == '\r' && !quote) { ++row; col = 0; }
      else arr[row][col] += cc;
  }
  return arr;
}

function maybeParseArray(s) { // this data structure sucks... should probably have changed it.
  if (s===null || s===undefined || s[0]!=="{" || s[s.length-1]!=="}") {
    return s;
  }
  try {
    const arr=parseCSV(s.substring(1, s.length-1));
    return arr.flat();
  } catch (e) {}
  return s;
}

function addGuestAttendance(allData, guests) {
  const userQuestion = allData.user_question.find(({question_number}) => question_number===Qnos.attendance);
  for (const guest of guests) {
    const result = allData.responses.find((r) =>
      r.question_id===userQuestion?.id && r.guest_id===guest.id
    );
    guest.attendance = maybeParseArray(result?.response);
  }
}

function addGuestofGuestAttendance(allData, gogs) {
  const userQuestion = allData.user_question.find(({question_number}) => question_number===Qnos.attendance);
  for (const gog of gogs) {
    const result = allData.gogs_responses.find((r) =>
      r.question_id===userQuestion?.id && r.gog_id===gog.id
    );
    gog.attendance = maybeParseArray(result?.response);
  }
}

function findGuest(allData, guest_id) {
  const guest = allData.guests.find(({id})=>id===guest_id) || {};
  guest.rsvp_code = allData.rsvp_codes.find(c => c.guest_id===guest_id)?.code;
  return guest;
}

function genericReport(allData, questionNames) {
  const questionNumbers = questionNames.map(q=>(q.substring(0,2)==="c_") ? Number(q.substring(2)) : Qnos[q]);

  // get question number to Qno map
  const qNoToUserQuestionNo={};
  const userQuestionIdToFieldName={};

  for (const userQuestion of allData.user_question) {
    const idx = questionNumbers.indexOf(userQuestion.question_number);
    if (idx>=0) {
      qNoToUserQuestionNo[userQuestion.question_number] = userQuestion.id;
      userQuestionIdToFieldName[userQuestion.id] = questionNames[idx];
    }
  }

  // build results from deduplicated responses
  const guestResult=[];
  const guestById={};
  for (const response of allData.responses) {
    const fieldName = userQuestionIdToFieldName[response.question_id];
    if (fieldName!==undefined && response.response!="" && response.response!=="no" ) {
      if (!guestById[response.guest_id]) { // new guest
        const guest = findGuest(allData, response.guest_id);
        guestResult.push(guest);
        guestById[response.guest_id] = guest;
      }
      guestById[response.guest_id][fieldName] = maybeParseArray(response.response);
      guestById[response.guest_id][fieldName+"_details"] = response.extra_details;
    }
  }

  addGuestAttendance(allData, guestResult);

  // build guest of guests results from deduplicated guest of guest responses
  const gogResult = [];
  const gogById = {};
  for (const response of allData.gogs_responses) {
    const fieldName = userQuestionIdToFieldName[response.question_id];
    if (fieldName!==undefined && response.response!="" && response.response!=="no" ) {
      if (!gogById[response.gog_id]) { // new guest of guest
        const gog = allData.gogs.find(({id})=>id===response.gog_id) || {};
        gog.gog_id = gog.id;
        gog.parentGuest = guestById[gog.guest_id];
        if (gog.parentGuest===undefined) {
          gog.parentGuest = findGuest(allData, gog.guest_id);
          addGuestAttendance(allData, [gog.parentGuest]);
        }
        gog.guest_name = gog.gog_name;
        gogResult.push(gog);
        gogById[response.gog_id] = gog;
      }
      gogById[response.gog_id][fieldName] = maybeParseArray(response.response);
      gogById[response.gog_id][fieldName+"_details"] = response.extra_details;
    }
  }

  addGuestofGuestAttendance(allData, gogResult);

  const fullResults = guestResult.concat(gogResult);

  fullResults.sort(resultsSort);

  return fullResults;
}

function resultsSort(a,b) {
  var aSortOn = a.parentGuest ? a.parentGuest.guest_name +" "+ a.gog_name : a.guest_name;
  var bSortOn = b.parentGuest ? b.parentGuest.guest_name +" "+ b.gog_name : b.guest_name;
  aSortOn = aSortOn.toLowerCase();
  bSortOn = bSortOn.toLowerCase();
  if (aSortOn<bSortOn) return -1;
  if (aSortOn>bSortOn) return 1;
  return 0;
}

const hasQuestions = (allData, questionNames) => {
  const questionNumbers = questionNames.map(q=>Qnos[q]);
  const matches = allData?.user_question.filter(q=>questionNumbers.indexOf(q.question_number)>=0);
  return matches.length >= questionNames.length;
};

function expectedReport(allData) {
  const result=[];
  if (!allData || !allData.guests) return [];
  for (const guest of allData.guests) {
    result.push(guest);
  }
  result.sort(resultsSort);
  return result;
}

function fieldName(id) {
  const r=Object.keys(Qnos).find(key => Qnos[key] === id);
  if (r) return r;
  return "c_" + id;
}

export {
  genericReport,
  hasQuestions,
  expectedReport,
  fieldName,
};
